import React, { useState, useEffect } from "react";
import { withRouter } from "react-router-dom";
import * as codebook from "./core-module/services/codebook";
import * as api from "./core-module/services/api";
import "./assets/css/index.css";
import LoadingBox from "./common/components/LoadingBox";
import Main from "./layouts/main";
import Forbidden from "./views/forbidden";
import config from "./config";

import getVar from "./core-module/tiny-functions/getVar";

//import AutoLocation from "views/autolocation/index.js";

const allRequests = async (history) => {
  await codebook.downloadURL("guest.1/canadaregions");
  await codebook.downloadURL("guest.1/areas");
  let agent = null;

  const contactid = getVar("contactid");
  if (contactid) {
    agent = Number(contactid);
    window.sessionStorage.setItem("agent", JSON.stringify({ agent: agent }));
  } else {
    let restoredagent = window.sessionStorage.getItem("agent");
    if (restoredagent != null) {
      restoredagent = JSON.parse(restoredagent);
      agent = restoredagent.agent;
    }
  }

  const res = await api.get("guest.1/handshake");

  return [res?.success, agent];
};

const Splash = (props) => {
  const [loading, setLoading] = useState(true);
  const [forbidden, setForbidden] = useState(false);
  const [agent, setAgent] = useState(null);
  const [needCaptcha, setNeedCaptcha] = useState(true);

  useEffect(() => {
    allRequests(props.history).then(([success, agentid]) => {
      if (success === false && agentid == null) {
        setForbidden(true);
      } else {
        setNeedCaptcha(config.IS_LOCAL_ENV ? false : success);
        setAgent(agentid);
        setLoading(false);
      }
    });
  }, []);

  if (forbidden) {
    return <Forbidden />;
  }

  if (loading) {
    return <LoadingBox />;
  }

  return <Main agent={agent} needCaptcha={needCaptcha} />;
};

export default withRouter(Splash);
